import apiClient from "@/shared/api/apiClient";

export const getOrganizationList = async (params) => {
  try {
    const { data } = await apiClient.get("/organizations/list/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getOrganizationList failed", e);
  }
};

export const getOrganizationItem = async (id, { signal } = {}) => {
  try {
    const { data } = await apiClient.get(`/organizations/${id}/`, { signal });
    return data;
  } catch (e) {
    if (e?.name === "CanceledError" || e?.code === "ERR_CANCELED") throw e;
    console.error("getOrganizationItem failed", e);
  }
};

export const getOrganizationName = async (id, { signal } = {}) => {
  const response = await apiClient
    .get(`/organizations/${id}/`, { signal })
    .then((r) => r.data);

  const raw = response?.payload ?? response ?? {};
  return (
    raw?.name ??
    raw?.short_name ??
    raw?.short_name_ru ??
    raw?.name_ru ??
    raw?.title ??
    null
  );
};

export const createOrganization = async (params) => {
  const result = await apiClient.post(`/organizations/`, {
    ...params,
  });
  return result.data;
};

export const updateOrganization = async (id, params) => {
  const { data } = await apiClient.put(`/organizations/${id}`, {
    ...params,
  });
  return data;
};

export const removeOrganization = async (id) => {
  const { data } = await apiClient.delete(`/organizations/${id}`);
  return data;
};

export const addRoleToOrganization = async (id, params) => {
  const result = await apiClient.post(
    `/organizations/${id}/employee/${params.role_code}`
  );
  return result.data;
};

export const removeRoleFromOrganization = async (id, params) => {
  const result = await apiClient.delete(
    `/organizations/${id}/employee/${params.role_code}`
  );
  return result.data;
};
